import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/page/index'    //国际化版跟读
import correct from '@/page/correct'    //国际化版跟读
import growup from '@/page/growup'    //国际化版跟读
import about from '@/page/about'    //国际化版跟读
import protacal from '@/page/protacal'    //国际化版跟读
import colloquial from '@/page/colloquial'    //国际化版跟读





const baseRoutes = [
  {  path: '/', name: 'Home', component: Home, meta: { keepAlive: false } },
  {  path: '/correct', name: 'correct', component: correct, meta: { keepAlive: false } },
  {  path: '/growup', name: 'growup', component: growup, meta: { keepAlive: false } },
  {  path: '/about', name: 'about', component: about, meta: { keepAlive: false } },
  {  path: '/protacal', name: 'protacal', component: protacal, meta: { keepAlive: false } },
  {  path: '/colloquial', name: 'colloquial', component: colloquial, meta: { keepAlive: false } },

];

const routes = baseRoutes;

Vue.use(Router)

export default new Router({
  routes
})



// WEBPACK FOOTER //
// ./src/router/index.js